export const services = [
  {
    id: 1,
    title: "Lectura General de Tarot",
    description: "Una visión completa de tu situación actual, energías presentes y posibles caminos futuros.",
    duration: "30 min",
    price: "25€",
    image: "https://public.readdy.ai/ai/img_res/29b1e137e113100816f457519ae65b93.jpg",
  },
  {
    id: 2,
    title: "Lectura de Amor y Relaciones",
    description: "Explora las energías de tus relaciones, compatibilidades y el camino hacia el amor verdadero.",
    duration: "45 min",
    price: "20€",
    image: "https://readdy.ai/api/search-image?query=two%20tarot%20cards%20with%20rose%20petals%20and%20soft%20candlelight%20on%20dark%20background%2C%20romantic%20mystical%20atmosphere%2C%20golden%20tones%2C%20esoteric%20love%20reading&width=600&height=700&seq=svc2&orientation=portrait",
  },
  {
    id: 3,
    title: "Lectura Anual Completa",
    description: "Un recorrido mes a mes por el año que viene, con guía para cada etapa de tu camino.",
    duration: "60 min",
    price: "70€",
    image: "https://readdy.ai/api/search-image?query=full%20tarot%20spread%20with%20twelve%20cards%20arranged%20in%20circle%20on%20dark%20mystical%20background%20with%20stars%20and%20moon%20symbols%2C%20golden%20candlelight%2C%20spiritual%20reading&width=600&height=700&seq=svc3&orientation=portrait",
  },
];

export const faqs = [
  {
    id: 1,
    question: "¿Cómo funciona una lectura de tarot?",
    answer: "Durante la sesión, formularás tus preguntas o inquietudes y yo realizaré una tirada de cartas específica para tu situación. Cada carta aporta un mensaje simbólico que interpretamos juntas para darte claridad y orientación.",
  },
  {
    id: 2,
    question: "¿Las lecturas son presenciales u online?",
    answer: "Ofrezco ambas modalidades. Las sesiones online se realizan por videollamada (Zoom o Google Meet) y son igual de efectivas que las presenciales. Puedes elegir la opción que más te convenga.",
  },
  {
    id: 3,
    question: "¿Cuánto dura una sesión?",
    answer: "Depende del servicio elegido: la Lectura General dura 30 minutos, la Lectura de Amor 45 minutos y la Lectura Anual 60 minutos. Siempre respeto los tiempos para que la sesión sea completa y satisfactoria.",
  },
  {
    id: 4,
    question: "¿Necesito preparar algo antes de la sesión?",
    answer: "Te recomiendo llegar con una mente abierta y, si lo deseas, con algunas preguntas o áreas de tu vida sobre las que quieras reflexionar. No es necesario ningún conocimiento previo sobre el tarot.",
  },
  {
    id: 5,
    question: "¿El tarot predice el futuro?",
    answer: "El tarot no predice un futuro fijo, sino que muestra las energías y tendencias actuales que pueden influir en tu camino. Es una herramienta de autoconocimiento y reflexión que te ayuda a tomar decisiones más conscientes.",
  },
  {
    id: 6,
    question: "¿Cómo puedo reservar una sesión?",
    answer: "Puedes contactarme a través del formulario de esta página, por WhatsApp al +34 643 65 7183 o por email. Te responderé en menos de 24 horas para confirmar tu cita.",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "María García",
    initials: "MG",
    color: "bg-amber-100 text-amber-700",
    stars: 5,
    text: "Celeste tiene un don especial. Su lectura me ayudó a ver con claridad una situación que me tenía bloqueada desde hacía meses. Sus palabras fueron precisas y llenas de compasión. Totalmente recomendable.",
  },
  {
    id: 2,
    name: "Laura Martínez",
    initials: "LM",
    color: "bg-rose-100 text-rose-700",
    stars: 5,
    text: "Fue mi primera lectura de tarot y quedé impresionada. Celeste crea un ambiente de confianza y seguridad desde el primer momento. Todo lo que me dijo resonó profundamente conmigo.",
  },
  {
    id: 3,
    name: "Ana Rodríguez",
    initials: "AR",
    color: "bg-emerald-100 text-emerald-700",
    stars: 5,
    text: "Llevo dos años consultando con Celeste y cada lectura es una experiencia transformadora. Su intuición es increíble y siempre me da la perspectiva que necesito para avanzar.",
  },
  {
    id: 4,
    name: "Carmen López",
    initials: "CL",
    color: "bg-orange-100 text-orange-700",
    stars: 5,
    text: "La lectura anual que hice con Celeste fue un regalo para mí misma. Mes a mes ha ido cumpliéndose con una precisión asombrosa. Es una profesional excepcional con una sensibilidad única.",
  },
  {
    id: 5,
    name: "Isabel Fernández",
    initials: "IF",
    color: "bg-teal-100 text-teal-700",
    stars: 5,
    text: "Hice una consulta sobre mi relación y Celeste supo ver exactamente lo que estaba pasando. Me dio herramientas para entender la situación desde otro ángulo. Muy agradecida.",
  },
  {
    id: 6,
    name: "Sofía Jiménez",
    initials: "SJ",
    color: "bg-pink-100 text-pink-700",
    stars: 5,
    text: "Profesional, empática y muy precisa. Celeste tiene una forma de transmitir los mensajes del tarot que te llega al corazón. Cada sesión es una experiencia de crecimiento personal.",
  },
];
